<template>
  <v-app :style="style" :class="classNames">
    <DebugAlert v-if="nodeEnv === 'development'" />
    <router-view />
    <search v-if="$store.state.user" />
  </v-app>
</template>

<script>
import Search from '@/components/Search.vue';
import DebugAlert from './DebugAlert.vue';

const darkBackground = require('@/assets/img/bg-dark.jpg');
const lightBackground = require('@/assets/img/bg-light.jpg');

export default {
  components: {
    Search,
    DebugAlert,
  },

  data() {
    return {
      keyPressed: {},
    };
  },

  mounted() {
    this.$vuetify.theme.dark = this.$store.state.darkMode;
    window.addEventListener('keyup', this.keyUpEventHandler);
    window.addEventListener('keydown', this.keyDownEventHandler);
  },

  destroyed() {
    window.removeEventListener('keyup', this.keyUpEventHandler);
    window.removeEventListener('keydown', this.keyDownEventHandler);
  },

  methods: {
    keyDownEventHandler(e) {
      this.keyPressed[e.key + e.location] = true;
      if (
        this.keyPressed.F0 == true &&
        this.keyPressed.Shift1 == true &&
        this.keyPressed.Control1 == true
      ) {
        this.$store.commit('openSearch');
        this.keyPressed = {}; // reset key map
      }
    },

    keyUpEventHandler(e) {
      this.keyPressed[e.key + e.location] = false;
      this.keyPressed = {};
    },
  },

  computed: {
    backgroundImage() {
      return this.$store.state.darkMode
        ? darkBackground
        : lightBackground;
    },

    backgroundColor() {
      return this.$store.state.darkMode
        ? '#282828'
        : '#eee';
    },

    style() {
      return {
        // backgroundImage: `url(${this.backgroundImage})`,
        backgroundColor: this.backgroundColor,
      };
    },

    nodeEnv() {
      return process.env.NODE_ENV;
    },

    classNames() {
      return [
        'app-variant-' + process.env.VUE_APP_VARIANT,
        {
          'low-contrast-in-dark-mode': process.env.VUE_APP_VARIANT === 'sze',
        }
      ];
    }
  }
};
</script>


<style src="@/assets/fonts/materialdesignicons/materialdesignicons.min.css"></style>
<style lang="scss" src="@/style.scss"></style>
